module.exports = __webpack_public_path__ + "img/circle2green.ba6aa88a.png";